(() => {
  let scrim = document.querySelector('[data-ms-mega-scrim]');
  let escapeBound = false;
  let scrimBound = false;
  const observedMenus = new WeakSet();
  const previewCache = new Map();
  const INTENT_MS = 60;

  const ensureScrim = () => {
    if (!scrim) {
      scrim = document.createElement('div');
      scrim.className = 'ms-mega-menu__scrim';
      scrim.setAttribute('data-ms-mega-scrim', '');
      scrim.hidden = true;
      document.body.appendChild(scrim);
    }
    return scrim;
  };

  const queryMenus = (scope) => {
    const root = scope instanceof Element ? scope : document;
    return [...root.querySelectorAll('.ms-mega-menu--fabric, .ms-mega-menu--use')];
  };

  const closeSiblingMegas = (keep) => {
    queryMenus().forEach((menu) => {
      if (menu !== keep && menu.open) menu.open = false;
    });
  };

  const syncScrim = () => {
    const open = document.querySelector('.ms-mega-menu--fabric[open], .ms-mega-menu--use[open]');
    const isOpen = Boolean(open);
    const layer = ensureScrim();
    layer.hidden = !isOpen;
    document.body.classList.toggle('ms-mega-menu-open', isOpen);
    const header = document.querySelector('.section-header');
    const pill = header && header.querySelector('.header');
    if (isOpen && header) {
      header.classList.remove('shopify-section-header-hidden');
      header.classList.add('shopify-section-header-sticky');
    }
    const pillRect = pill ? pill.getBoundingClientRect() : null;
    if (isOpen && pillRect) {
      document.documentElement.style.setProperty('--ms-mega-top', `${Math.round(pillRect.bottom + 10)}px`);
    }
  };

  const pinMegaToHeader = () => {
    if (!document.body.classList.contains('ms-mega-menu-open')) return;
    const pill = document.querySelector('.section-header .header');
    if (!pill) return;
    document.documentElement.style.setProperty('--ms-mega-top', `${Math.round(pill.getBoundingClientRect().bottom + 10)}px`);
  };

  const loadPreview = (src) => {
    if (!src) return Promise.resolve(false);
    if (previewCache.has(src)) return previewCache.get(src);
    const promise = new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const decoded = typeof img.decode === 'function' ? img.decode().then(() => true, () => true) : Promise.resolve(true);
        decoded.then(() => resolve(true));
      };
      img.onerror = () => {
        previewCache.delete(src);
        resolve(false);
      };
      img.src = src;
    });
    previewCache.set(src, promise);
    return promise;
  };

  const bindMenu = (menu) => {
    if (menu.dataset.msMegaBound === 'true') return;
    const previewImage = menu.querySelector('[data-ms-mega-preview-image]');
    const previewTitle = menu.querySelector('[data-ms-mega-preview-title]');
    const previewEyebrow = menu.querySelector('[data-ms-mega-preview-eyebrow]');
    const noteTitle = menu.querySelector('[data-ms-mega-note-title]');
    const noteCopy = menu.querySelector('[data-ms-mega-note-copy]');
    const links = menu.querySelectorAll('[data-preview]');
    if (!previewImage || !previewTitle || !links.length) return;

    menu.dataset.msMegaBound = 'true';

    const summary = menu.querySelector('summary');
    const prepareOpen = () => {
      closeSiblingMegas(menu);
    };
    if (summary) {
      summary.addEventListener('pointerdown', prepareOpen, true);
      summary.addEventListener('pointerenter', prepareOpen, true);
      summary.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') prepareOpen();
      }, true);
    }

    let generation = 0;
    let intentTimer = 0;
    let intentLink = null;
    let lastPointer = { x: 0, y: 0 };

    menu.addEventListener('pointermove', (event) => {
      lastPointer = { x: event.clientX, y: event.clientY };
    }, { passive: true });

    const invalidateIntent = ({ clearOutgoing = true } = {}) => {
      generation += 1;
      window.clearTimeout(intentTimer);
      intentTimer = 0;
      intentLink = null;
      if (clearOutgoing) previewImage.classList.remove('is-outgoing');
      return generation;
    };

    const beginIntent = (link) => {
      generation += 1;
      window.clearTimeout(intentTimer);
      intentTimer = 0;
      intentLink = link;
      return generation;
    };

    const intentIsCurrent = (link, expectedGeneration) => (
      generation === expectedGeneration
      && intentLink === link
      && menu.open
      && menu.isConnected
      && link.isConnected
      && previewImage.isConnected
    );

    const sameSrc = (src) => {
      const current = previewImage.getAttribute('src') || '';
      return current === src || previewImage.currentSrc === src || previewImage.currentSrc.endsWith(src.replace(/^https?:/, '')) || current === src.replace(/^https?:/, '');
    };

    const pointerStillOnLink = (link) => {
      if (!lastPointer.x && !lastPointer.y) return true;
      const hit = document.elementFromPoint(lastPointer.x, lastPointer.y);
      if (!(hit instanceof Element)) return true;
      const hitLink = hit.closest('[data-preview]');
      if (hitLink && hitLink !== link) return false;
      return true;
    };

    const commitPreview = async (link, expectedGeneration) => {
      if (!intentIsCurrent(link, expectedGeneration)) return;
      if (!pointerStillOnLink(link)) return;
      const src = link.getAttribute('data-preview');
      if (!src) return;

      const title = link.getAttribute('data-title');
      if (title) {
        previewTitle.textContent = title;
        previewImage.alt = title;
      }
      if (previewEyebrow && link.getAttribute('data-preview-eyebrow')) previewEyebrow.textContent = link.getAttribute('data-preview-eyebrow');
      if (noteTitle && link.getAttribute('data-note-title')) noteTitle.textContent = link.getAttribute('data-note-title');
      if (noteCopy && link.getAttribute('data-note-copy')) noteCopy.textContent = link.getAttribute('data-note-copy');
      links.forEach((item) => item.classList.remove('is-preview'));
      link.classList.add('is-preview');

      const already = sameSrc(src);
      if (already) return;
      const loaded = await loadPreview(src);
      if (!loaded || !intentIsCurrent(link, expectedGeneration) || !pointerStillOnLink(link)) return;
      previewImage.src = src;
    };

    const queuePointerPreview = (link) => {
      if (intentLink === link) return;
      const expectedGeneration = beginIntent(link);
      intentTimer = window.setTimeout(() => {
        intentTimer = 0;
        commitPreview(link, expectedGeneration);
      }, INTENT_MS);
    };

    const cancelPointerPreview = (link) => {
      if (intentLink === link) invalidateIntent();
    };

    links.forEach((link) => {
      link.addEventListener('pointerenter', () => queuePointerPreview(link));
      link.addEventListener('pointerleave', () => cancelPointerPreview(link));
      link.addEventListener('focus', () => {
        const expectedGeneration = beginIntent(link);
        commitPreview(link, expectedGeneration);
      });
    });

    menu.addEventListener('toggle', () => {
      if (menu.open) {
        closeSiblingMegas(menu);
      } else {
        invalidateIntent();
      }
      syncScrim();
    });
    if (!observedMenus.has(menu)) {
      const observer = new MutationObserver(() => {
        if (menu.open) closeSiblingMegas(menu);
        else invalidateIntent();
        syncScrim();
      });
      observer.observe(menu, { attributes: true, attributeFilter: ['open'] });
      observedMenus.add(menu);
    }
  };

  const closeAllMegas = () => {
    queryMenus().forEach((details) => { details.open = false; });
    syncScrim();
  };

  const initHomepageNav = (scope = document) => {
    ensureScrim();
    queryMenus(scope).forEach(bindMenu);
    if (!escapeBound) {
      escapeBound = true;
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        closeAllMegas();
      });
    }
    if (!scrimBound) {
      scrimBound = true;
      ensureScrim().addEventListener('click', closeAllMegas);
    }
    syncScrim();
  };

  initHomepageNav();
  window.addEventListener('scroll', pinMegaToHeader, { passive: true });
  window.addEventListener('resize', pinMegaToHeader);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (!(section instanceof Element)) return;
    section.querySelectorAll('.ms-mega-menu--fabric, .ms-mega-menu--use').forEach((menu) => delete menu.dataset.msMegaBound);
    initHomepageNav(section);
  });
})();
